import { ThemeToggle } from '@lean-agility/design-system/react';
import { useThemeContext } from '@/contexts/useThemeContext';

export type { ThemeToggleProps } from '@lean-agility/design-system/react';
export { ThemeToggle };

/**
 * Connected version that automatically uses ThemeProvider context.
 * Use this when you want the component to manage its own state via context.
 */
export function ConnectedThemeToggle({ className }: { className?: string }) {
  const { theme, toggleTheme, mounted } = useThemeContext();
  return <ThemeToggle theme={theme} onToggle={toggleTheme} mounted={mounted} className={className} />;
}
